export const SET_PERMISSIONS = 'permissions/set-permissions';
export const SET_LOGGED_USER_PERMISSIONS = 'permissions/set-logged-user-permissions';
export const CLEAR_LOGGED_USER_PERMISSIONS = 'permissions/clear-logged-user-permissions';
export const SET_MY_GROUP_PERMISSIONS = 'permissions/set-my-group-permissions';
export const SET_LOGGED_USER_PERMISSIONS_LOADED = 'permissions/set-logged-user-permissions-loaded';
